/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/~/lodash/_freeGlobal.js
// module id = 737
// module chunks = 0